import jszip from 'jszip';
import 'datatables.net-bs4';
import 'datatables.net-buttons-bs4';
// import 'pdfmake';
import 'datatables.net-buttons/js/buttons.colVis';
import 'datatables.net-buttons/js/buttons.html5';
import 'datatables.net-fixedcolumns/js/dataTables.fixedColumns.js';
import 'datatables.net-fixedheader-bs4';
import './datatable-select';

window.JSZip = jszip;

// Este modulo registra handlers em `$(document)` no escopo do arquivo. Partials
// injetadas por ajax (reservation_containers/documents/reload_tables.js.slim,
// os modais com `javascript_pack_tag` no corpo) fazem o jQuery reavaliar o pack,
// e cada reexecucao somava mais um conjunto completo de handlers: depois de N
// reloads cada draw reescrevia os badges N vezes e cada XHR passava por N
// handlers de abort.
//
// `.off()` com namespace resolve, e sem trava global: o jQuery testa o namespace
// do TRIGGER contra o do HANDLER (`event.rnamespace.test(handleObj.namespace)`),
// entao um handler em `preXhr.dt.contrailDt` recebe o `preXhr.dt` que o
// DataTables dispara - `/(^|\.)dt(\.|$)/.test('contraildt.dt') === true`. E o
// mesmo padrao de `packs/custom_selectize.js` (`shown.bs.modal.selectize`).
// Namespace POR HANDLER, e nao um `.contrailDt` compartilhado: o `.off()` do
// jQuery remove todo handler cujo conjunto de namespaces contenha os pedidos,
// entao com um namespace so cada registro apagava os anteriores do MESMO tipo de
// evento. Sao tres `preXhr.dt`, dois `xhr.dt` e dois `draw.dt` - sobreviviam 3
// dos 7, e os mortos eram justamente a injecao de `data.filtering` (toda tela
// com FILTRAR ficaria vazia para sempre), o token CSRF e o `#status-rowTotal`.
//
// O contador reinicia a cada avaliacao do modulo, entao o registro n de uma
// reavaliacao continua apagando o registro n da anterior - que e a
// idempotencia que se queria aqui.
const DT_NS = '.contrailDt';
let dtHandlerSeq = 0;

function onDocumentDt(events, handler) {
  dtHandlerSeq += 1;
  const suffix = DT_NS + dtHandlerSeq;
  const namespaced = events
    .split(' ')
    .map((event) => event + suffix)
    .join(' ');

  $(document).off(namespaced).on(namespaced, handler);
}

// Menu de paginacao padrao das telas que nao declaram `lengthMenu` proprio - o
// mesmo das que declaram, para o usuario nao encontrar opcoes diferentes de uma
// tela para a vizinha.
//
// A ultima opcao e 1500 (o `ApplicationDatatable::MAX_PAGE_SIZE`) e nao o `-1`
// de "Todos": com `-1` o DataTables monta UMA pagina so e esconde a paginacao,
// mas o servidor corta em 1500 assim mesmo - o usuario via 1500 linhas, "Pagina
// 1 de 1" e nenhum aviso de que existiam outras 284.024. Pior no export, que em
// modo server-side leva so o que esta no DOM. Como tamanho de pagina o mesmo
// 1500 aparece com "Pagina 1 de N", o rodape diz o total e toda linha continua
// alcancavel - nada e cortado em silencio.
//
// Atribuicao direta em vez de `$.extend(true, ...)`: o extend profundo do jQuery
// mescla array por indice, entao uma tela que declara `lengthMenu` com dois
// elementos (o par valores/rotulos) herdaria o terceiro elemento deste default.
$.fn.dataTable.defaults.lengthMenu = [
  [10, 25, 50, 100, 250, 500, 1500],
  [10, 25, 50, 100, 250, 500, '1.500 (lento)'],
];

// Traducao da interface. Estava copiada byte a byte em 37 arquivos de tela (e em
// 5 com variacao pequena), entao mudar um texto exigia 42 edicoes e quem
// esquecesse um deixava a tela em ingles. O DataTables monta as opcoes com
// `$.extend(true, {}, defaults, oInit)`, entao a tela que precisar de uma chave
// diferente sobrescreve so aquela chave e herda o resto.
$.extend(true, $.fn.dataTable.defaults, {
  language: {
    // Mesmo skeleton de layouts/_skeleton_loader, para o carregamento ter uma
    // cara so no sistema inteiro.
    processing: `<div class="skeleton">${'<div class="skeleton-row"></div>'.repeat(
      10
    )}</div><span class="sr-only">Carregando...</span>`,
    lengthMenu: 'Mostrar _MENU_ resultados por página',
    zeroRecords: 'Nenhum dado encontrado',
    // Sem esta chave a tela sem botao FILTRAR (cadastros, tabelas de modal)
    // caia no "No data available in table" do DataTables:
    // o `emptyTable` em portugues so era injetado no bloco de ready abaixo, que
    // roda apenas quando existe `.dt-filter-action` na pagina.
    emptyTable: 'Nenhum dado encontrado',
    info: 'Página _PAGE_ de _PAGES_',
    infoEmpty: 'Nenhum dado encontrado',
    infoFiltered: '(Total de _MAX_ registros)',
    search: 'Pesquisar: ',
    searchPlaceholder: 'Insira sua pesquisa...',
  },
});

// O token do CSRF ia em `ajax.data` de cada tela - 34 copias da mesma linha, e
// tela nova que esquecesse tomava 422. Sai daqui uma vez so, no mesmo lugar onde
// o `filtering` ja e injetado.
onDocumentDt('preXhr.dt', (_event, _settings, data) => {
  // `window._token` continua sendo emitido a mao em ~34 views; quando uma tela
  // nova esquece a linha o POST tomava 422 sem erro no console. A meta tag do
  // `csrf_meta_tags` esta sempre no layout, entao serve de fallback.
  data.authenticity_token =
    window._token || $('meta[name="csrf-token"]').attr('content');
});

// O `preXhr.dt` acima so chega se a tabela estiver no DOM: evento de tabela
// desanexada (instancia antiga de um modal reaberto) nao sobe ate `document`, e
// o POST saia sem token - 422 e o alert "Ajax error" (06/10/2026). O header vale
// para qualquer XHR deste jQuery, anexado ou nao. Cada pack traz a propria copia
// do jQuery (ProvidePlugin), por isso o prefilter do rails-ujs nao alcanca estas
// requisicoes; a marca em `$` registra uma vez por copia.
if (!$.contrailCsrfPrefilter) {
  $.contrailCsrfPrefilter = true;
  $.ajaxPrefilter((options, _originalOptions, xhr) => {
    if (options.crossDomain) return;
    const token = window._token || $('meta[name="csrf-token"]').attr('content');
    if (token) xhr.setRequestHeader('X-CSRF-Token', token);
  });
}

$.extend(true, $.fn.dataTable.defaults, {
  // Toda tela abre em 25 linhas, independente do que o usuario tenha escolhido
  // na visita anterior: a escolha de 50 ou 100 vale para a sessao de trabalho e
  // nao fica presa no proximo carregamento.
  //
  // 25 e nao 10: antes da varredura cada tela declarava 25, 50, 100 ou 150, e o
  // `pageLength` tambem manda em quanto o Copiar/Excel do DataTables Buttons
  // consegue exportar - em modo server-side o export le so as linhas que estao
  // no DOM. Com 10 todo export virava 10 linhas.
  pageLength: 25,
});

// Busca global com debounce de verdade. O `searchDelay` do DataTables 1.10 e
// THROTTLE (`_fnThrottle`): enquanto a pessoa digita ele dispara uma busca a
// cada 400/800ms, e cada uma varre a base inteira no servidor - no Tracking,
// digitar "ROTA" gerava busca para "RO" antes de terminar (25/09/2026). Aqui a
// busca so sai 3s depois da ultima tecla; Enter e limpar a caixa buscam na hora.
// Os handlers `.DT` e o `mouseup` do DataTables (o do icone de limpar do Edge,
// que buscava no clique) saem porque passariam por cima do debounce.
const SEARCH_DEBOUNCE_MS = 3000;

onDocumentDt('init.dt', (_event, settings) => {
  const api = new $.fn.dataTable.Api(settings);
  const $input = $(api.table().container()).find('.dataTables_filter input');
  if ($input.length === 0) return;

  let timer;
  const search = () => {
    clearTimeout(timer);
    if (api.search() !== $input.val()) api.search($input.val()).draw();
  };

  $input
    .off('.DT mouseup')
    .on('input.contrailSearch', () => {
      clearTimeout(timer);
      if ($input.val() === '') {
        search();
      } else {
        timer = setTimeout(search, SEARCH_DEBOUNCE_MS);
      }
    })
    .on('keypress.contrailSearch', (e) => {
      // Enter busca na hora e nao submete o form em volta.
      if (e.keyCode !== 13) return undefined;
      search();
      return false;
    });
});

// Nas telas que tem o botao FILTRAR a tabela deixa de carregar sozinha: o
// usuario escolhe o filtro e so entao a consulta sai. `deferLoading: 0` faz o
// DataTables pular o ajax da abertura (jquery.dataTables.js trata o valor como
// "ja tenho 0 registros"), e `emptyTable` explica o que fazer, porque a tela
// abrir vazia muda o que o usuario esperava.
//
// As telas de cadastro (clientes, navios, motoristas, locais) nao tem esse
// botao e continuam carregando na abertura - sao tabelas pequenas e sem o
// botao nao haveria como pedir os dados.
//
// Este callback de ready e registrado no import, antes do que monta a tabela em
// cada arquivo, entao o default ja esta valendo na hora da construcao.
$(() => {
  if ($('.dt-filter-action').length === 0) {
    return;
  }

  $.extend(true, $.fn.dataTable.defaults, {
    deferLoading: 0,
    language: {
      emptyTable: 'Clique em FILTRAR para carregar os dados.',
    },
  });

  // Ate `loadDtFilters` ligar os handlers o botao nao faz nada: a maioria das
  // telas so monta a tabela depois do `$.get` do `adjustColumns`, e o clique
  // dado nessa janela se perdia sem aviso. Desabilitado ate la - quem reabilita
  // e o proprio `loadDtFilters` (filters.js).
  // ponytail: rede de 15s para tela que tenha o botao e nunca chame
  // `loadDtFilters` - nao ha lista garantida das 20 views com FILTRAR.
  const $buttons = $('.dt-filter-action, .dt-filter-no-date');
  $buttons.prop('disabled', true);
  setTimeout(() => $buttons.prop('disabled', false), 15000);
});

// Escopo da tela a que a tabela pertence. Os seletores abaixo varriam o
// documento inteiro: numa pagina com duas tabelas a segunda enxergava o botao
// FILTRAR da primeira e nunca desenhava, e o `#filtering` encontrado era sempre
// o da primeira. `.modal` vem antes de `.container-fluid` de proposito - e o que
// isola a tabela que mora dentro de um modal da tela de tras.
function dtScope(table) {
  const scope = $(table).closest('.modal, .container-fluid');

  return scope.length > 0 ? scope : $(document.body);
}

// `loadDtFilters` cria o `<input id="filtering">` dentro da propria <table>
// (filters.js), entao da para achar o da tabela certa. Seletor composto de
// proposito: `find('#filtering')` cai no atalho de getElementById do Sizzle, que
// com id duplicado devolve sempre o input da primeira tabela da pagina.
function filteringInput(table) {
  return $(table).find('input#filtering');
}

// Os badges nem sempre ficam dentro do escopo da tabela: em commercial_routes e
// em route_sections o `#status-rowTotal` e irmao do `.container-fluid`, nao
// filho dele. Sem badge no escopo vale o documento inteiro, que e o
// comportamento de hoje e o unico que funciona nessas telas. Dentro de modal nao
// ha fallback - se o modal nao tem badge, a tabela dele nao mexe nos da tela de
// tras.
// `span[id^=...]` e nao `[id^=...]`: o handler de badges faz `text('0')` em tudo
// que casar, e o fallback abaixo varre o documento inteiro - um dia um
// `select#status-alguma-coisa` num filtro seria zerado a cada draw. Hoje todo
// elemento `#status-*` das views e um span (conferido em 09/09/2026 sobre as 253
// ocorrencias em app/views), entao restringir nao muda nada e fecha a porta.
// Nada garante o invariante alem dessa conferencia.
const BADGE_SELECTOR = 'span[id^="status-"]';

function dtBadges(table) {
  const scope = dtScope(table);
  const scoped = scope.find(BADGE_SELECTOR);

  if (scoped.length > 0 || scope.is('.modal')) {
    return scoped;
  }

  return $(BADGE_SELECTOR);
}

// O `deferLoading: 0` acima e um default da pagina inteira, e o DataTables le
// essa opcao na construcao da tabela (jquery.dataTables.js:1066) - nao da para
// variar por tabela dali. Entao a segunda tabela da pagina (a de dentro de um
// modal, por exemplo), que nao tem FILTRAR nenhum, herdava o default e nunca
// buscava dado na abertura. Aqui ela busca, que e o que faria se a pagina nao
// tivesse botao de filtro. A tabela com FILTRAR proprio continua esperando o
// clique.
// A marca e gravada no `preInit` porque nenhum dos dois lugares obvios serve no
// momento do `init`:
//
// - `settings.oInit` e o objeto de inicializacao CRU da tabela
//   (jquery.dataTables.js:963), guardado ANTES de os defaults serem mesclados
//   num objeto novo na linha 984. O default global nunca aparece la, entao a
//   guarda anterior (`settings.oInit.deferLoading === undefined`) saia sempre
//   pelo early return e este handler inteiro era codigo morto - a tabela
//   secundaria de uma tela com FILTRAR herdava `deferLoading`, nunca buscava
//   dado e ficava exibindo "Clique em FILTRAR" sem ter botao.
// - `settings.bDeferLoading` E o valor efetivo (a linha 1066 o liga a partir do
//   default ja mesclado), mas o primeiro `_fnDraw` o zera na linha 3458, e o
//   evento `init` so dispara depois disso (`_fnInitComplete`, linha 4830).
//
// `preInit` (linha 4772) roda depois do mapeamento das opcoes e antes do
// primeiro draw, que e a unica janela em que o valor esta de pe.
onDocumentDt('preInit.dt', (_event, settings) => {
  settings.contrailWasDeferred = settings.bDeferLoading === true;
});

onDocumentDt('init.dt', (_event, settings) => {
  // Marca o fim da construcao para TODA tabela, inclusive a que nunca foi
  // adiada - o `preDraw` abaixo usa isto para distinguir os draws extras do
  // FixedColumns dos draws de verdade.
  settings.contrailInitDone = true;

  if (!settings.contrailWasDeferred) {
    return;
  }

  // `setTimeout(0)`: `loadDtFilters` roda no mesmo tick, logo depois do
  // `.DataTable({...})` que acabou de disparar este `init`. Decidir agora leria
  // um `#filtering` que ainda nao existe e trataria toda tabela como se nao
  // tivesse optado pelo carregamento sob demanda.
  setTimeout(() => {
    if (filteringInput(settings.nTable).length > 0) {
      return;
    }

    new $.fn.dataTable.Api(settings).ajax.reload(null, false);
  }, 0);
});

// `deferLoading: 0` evita o ajax da abertura, mas o FixedColumns desfaz isso:
// ao ser construido ele chama `fnDraw(false)` para reajustar as colunas
// congeladas (dataTables.fixedColumns.js:691), e em modo server-side todo draw
// dispara requisicao. Medido na tela de Reservas: tres POSTs antes de o usuario
// clicar em qualquer coisa.
//
// `preDraw` roda no topo de `_fnDraw`, antes do ajax, e o DataTables cancela o
// draw quando algum handler devolve false (jquery.dataTables.js:3422). O
// primeiro draw passa - e ele que pinta a mensagem de tabela vazia; os
// seguintes sao barrados ate o usuario filtrar.
onDocumentDt('preDraw.dt', (_event, settings) => {
  // O draw com `bDeferLoading` ligado nao faz ajax: e ele que desliga a flag
  // (jquery.dataTables.js:3458). Esse draw e o do `_fnReDraw` da construcao,
  // que roda antes de `loadDtFilters` criar o `#filtering` - a regra da janela
  // de construcao abaixo o cancelava, a flag sobrevivia e o PRIMEIRO clique em
  // FILTRAR era consumido por ela (desenhava a tabela vazia sem POST). So o
  // segundo clique buscava dado.
  if (settings.bDeferLoading) {
    return undefined;
  }

  const filtering = filteringInput(settings.nTable);

  // So participa do carregamento sob demanda a tabela que tem o proprio
  // `#filtering` - ou seja, a que chamou `loadDtFilters`.
  //
  // O fallback pelo botao FILTRAR no escopo, que existia aqui, barrava tambem
  // quem nunca optou por participar: numa tela com FILTRAR, uma tabela sem
  // `#filtering` proprio caia neste caminho e `filtering.val()` era `undefined`,
  // que nunca vira 'true' - o bloqueio ficava permanente e paginacao, ordenacao
  // e busca paravam de funcionar depois do primeiro render, sem erro nenhum no
  // console.
  //
  // O preco e que os draws extras que o FixedColumns dispara durante a
  // construcao (antes de `loadDtFilters` criar o input) deixam de ser barrados
  // nessas tabelas. Elas nao sao as que tem o botao, entao carregar na abertura
  // e o comportamento correto para elas de qualquer forma.
  // Sem `#filtering` proprio a tabela nao participa do carregamento sob demanda,
  // com uma excecao: a janela de construcao. O input so existe depois de
  // `loadDtFilters`, que roda DEPOIS do `.DataTable({...})`, e e durante a
  // construcao que o FixedColumns dispara os draws extras (`fnDraw(false)`,
  // dataTables.fixedColumns.js:691) - em modo server-side, um POST cada.
  //
  // `contrailWasDeferred` sozinho nao serve para decidir participacao: o
  // `deferLoading: 0` e um default de PAGINA, entao numa tela com FILTRAR ele
  // vale para todas as tabelas, inclusive as que nao tem botao proprio - usa-lo
  // como criterio congelava essas tabelas depois do primeiro render.
  if (filtering.length === 0) {
    return settings.contrailWasDeferred && !settings.contrailInitDone
      ? false
      : undefined;
  }

  if (filtering.val() === 'true') {
    return undefined;
  }

  if (!settings.contrailFirstDrawDone) {
    settings.contrailFirstDrawDone = true;
    return undefined;
  }

  return false;
});

// `filtering` diz ao servidor que o usuario ja pediu os dados; sem ele os
// datatables com carregamento sob demanda devolvem `.none`. Cada arquivo
// mandava (ou esquecia de mandar) a sua propria linha `d.filtering` - 13 de 27
// mandavam, e as outras 14 nunca carregariam. Aqui sai uma vez so, para todos.
//
// Sem o input o parametro nao vai: numa tela cujo JS nao chama `loadDtFilters`
// ele saia como string vazia e o datatable com a guarda `filtering?` respondia
// `.none` - tela vazia para sempre, HTTP 200 e nenhum erro no console.
onDocumentDt('preXhr.dt', (_event, settings, data) => {
  const filtering = filteringInput(settings.nTable);

  if (filtering.length === 0) {
    return;
  }

  data.filtering = filtering.val() || '';
});

// Depois da primeira resposta a tabela vazia significa "o filtro nao achou
// nada", e nao "voce ainda nao clicou em FILTRAR". Sem isto a tela pede para
// clicar num botao que o usuario acabou de clicar.
onDocumentDt('xhr.dt', (_event, settings) => {
  if (filteringInput(settings.nTable).val() !== 'true') {
    return;
  }

  settings.oLanguage.sEmptyTable = 'Nenhum dado encontrado';
});

// Request obsoleto continuava em voo depois que o usuario mudava de pagina ou
// de filtro: a resposta antiga chegava depois da nova e a tela voltava para o
// resultado anterior. `preXhr` roda antes de `oSettings.jqXHR` ser
// reatribuido (jquery.dataTables.js:3956), entao aqui ainda da para abortar o
// anterior.
onDocumentDt('preXhr.dt', (_event, settings) => {
  const previous = settings.jqXHR;

  if (previous && previous.readyState !== 4) {
    // Marca antes de abortar: o `error` do DataTables dispara `xhr.dt` e so
    // deixa de mostrar "DataTables warning: Ajax error" se algum handler
    // devolver true (jquery.dataTables.js:3937). Sem a marca, paginar ou
    // refiltrar rapido vira alerta na cara do usuario.
    previous.contrailAborted = true;
    previous.abort();
  }
});

// Silencia so o request que nos mesmos abortamos - o `contrailAborted` e posto
// duas linhas acima. Erro de verdade (500, timeout, JSON invalido) continua
// alertando como antes.
onDocumentDt('xhr.dt', (_event, _settings, _json, xhr) =>
  xhr && xhr.contrailAborted === true ? true : undefined
);

// FILTRAR travado enquanto o request da tabela esta em voo. O abort acima so
// fecha a conexao do navegador: o Puma segue e a query roda ate o fim no banco.
// Na tela de Reservas uma busca de NF lenta virou 19 requests de ~50 s em
// paralelo, um por clique (909 s de banco em uma hora, 26/10/2026).
function filterButtons(table) {
  return dtScope(table).find('.dt-filter-action, .dt-filter-no-date');
}

onDocumentDt('preXhr.dt', (_event, settings) => {
  if (filteringInput(settings.nTable).length === 0) {
    return;
  }

  filterButtons(settings.nTable).prop('disabled', true);
});

// O `xhr.dt` tambem dispara no erro (500, timeout), entao o botao sempre volta.
// O request que nos mesmos abortamos fica de fora: o seguinte ainda esta em voo.
onDocumentDt('xhr.dt', (_event, settings, _json, xhr) => {
  if (xhr && xhr.contrailAborted === true) {
    return undefined;
  }

  filterButtons(settings.nTable).prop('disabled', false);
  return undefined;
});

// Comparador dos dois sentidos: aninhar ternario aqui era o unico jeito de
// escrever isso numa linha, e o lint reclamava com razao.
function compareDateEu(a, b) {
  if (a < b) {
    return -1;
  }

  return a > b ? 1 : 0;
}

export function dtPlugins() {
  jQuery.extend(jQuery.fn.dataTableExt.oSort, {
    'date-eu-pre': function (date) {
      date = date.split(' ');
      const hours = date[1];
      date = date[0].replace(' ', '');

      if (!date) {
        return 0;
      }

      let year;
      const eu_date = date.split(/[\.\-\/]/);

      /* year (optional) */
      if (eu_date[2]) {
        year = eu_date[2];
      } else {
        year = 0;
      }

      /* month */
      let month = eu_date[1];
      if (month.length === 1) {
        month = 0 + month;
      }

      /* day */
      let day = eu_date[0];
      if (day.length === 1) {
        day = 0 + day;
      }

      if (hours) {
        const time = hours.split(':');
        /* hour */
        let hour = time[0];
        if (hour.length === 1) {
          hour = 0 + hour;
        }
        /* minute */
        let minute = time[1];
        if (minute.length === 1) {
          minute = 0 + minute;
        }
        return (year + month + day + hour + minute) * 1;
      }
      return (year + month + day) * 1;
    },

    'date-eu-asc': function (a, b) {
      return compareDateEu(a, b);
    },

    'date-eu-desc': function (a, b) {
      return compareDateEu(b, a);
    },
  });
}

export function correctFooterAlignment() {
  setTimeout(function () {
    $('.DTFC_LeftFootWrapper .DTFC_Cloned .footer-item').each(function () {
      const index = $(this).data('index');
      const width = $(`.dataTables_scrollFootInner .footer-item-${index}`).css(
        'width'
      );
      $(this).css('width', width);
    });
    $('.DTFC_LeftFootWrapper .DTFC_Cloned .footer-item').keyup(function () {
      const input = $(this).children();
      $(`.dataTables_scrollFootInner .footer-item-${input.data('index')}`)
        .children()
        .val(input.val());
      $(`.dataTables_scrollFootInner .footer-item-${input.data('index')}`)
        .children()
        .change();
    });
  }, 100);
}

// `#status-rowTotal` ("Total de registros") era preenchido contando as linhas
// renderizadas — `dt.data()` / `dt.data().count()` devolvem só a pagina atual
// numa DataTable server-side. O badge mostrava 10 ou 25 numa base de centenas de
// milhares (clientes: "10" com 31 paginas; Expedicao: "25" com 29.182 paginas).
//
// `draw.dt` dispara depois dos `drawCallback` de cada tela, entao este handler
// tem a ultima palavra e corrige as 95 views que usam o badge, sem precisar
// mexer em cada JS. `recordsDisplay` e o total apos busca/filtro (igual ao
// `recordsTotal` quando nao ha busca), que e o que o rodape do DataTables ja
// mostra em "Total de _MAX_ registros".
onDocumentDt('draw.dt', function (event) {
  const el = dtBadges(event.target).filter('[id="status-rowTotal"]')[0];
  if (!el) return;

  const table = $(event.target).closest('table').DataTable();
  if (!table || typeof table.page !== 'function') return;

  // Tabela sem fonte ajax (tiju_report) e client-side: o badge dela vem
  // renderizado do servidor com um GROUP BY, e `recordsDisplay` aqui seria a
  // contagem do que esta na pagina - exatamente o numero que este handler
  // existe para substituir. `draw.dt` dispara nela tambem, por isso a guarda.
  const settings = table.settings()[0];
  if (settings && !settings.oInit.ajax && !settings.sAjaxSource) return;

  const info = table.page.info();
  if (info && typeof info.recordsDisplay === 'number') {
    el.textContent = info.recordsDisplay.toLocaleString('pt-BR');
  }
});

// Os badges de quebra (EM TRÂNSITO, IMPORTAÇÃO, RODOVIÁRIOS...) eram contados
// no rowCallback de cada tela, ou seja só sobre as linhas da página: apareciam
// "FINALIZADO: 24" ao lado de "Total: 729.542". Quando o datatable manda
// `status_counts` no JSON, esses números passam a vir do servidor, agregados
// sobre o mesmo conjunto do recordsFiltered. Roda depois do drawCallback da
// tela, então sobrescreve a contagem por página.
onDocumentDt('draw.dt', function (event) {
  const table = $(event.target).closest('table').DataTable();
  if (!table || typeof table.ajax !== 'object') return;

  let json;
  try {
    json = table.ajax.json();
  } catch (e) {
    return;
  }
  // `{}` e truthy: quando o `rescue StandardError` de um `status_counts` no
  // servidor devolve hash vazio, a guarda antiga passava, `badges.text('0')`
  // rodava e nenhuma chave casava - todo badge da tela ficava em 0 ao lado do
  // total real, indistinguivel de resultado legitimamente vazio.
  if (!json) return;

  // O servidor marca `badges_degraded` quando a agregacao levantou e foi
  // engolida (ApplicationDatatable#log_swallowed). Sem isso os badges caiam em
  // 0 e um zero afirmado com confianca e indistinguivel de um balde de fato
  // vazio - que foi o bug que originou esta varredura.
  if (json.badges_degraded) {
    // Escopo da tabela, sem o fallback de documento inteiro do `dtBadges`: uma
    // tabela sem badge proprio que degrade apagaria os badges corretos da tabela
    // vizinha.
    const scoped = dtScope(event.target).find(BADGE_SELECTOR);
    if (scoped.length === 0) return;

    scoped.not('[id="status-rowTotal"]').text('—');
    return;
  }

  if (!json.status_counts) return;
  if (Object.keys(json.status_counts).length === 0) return;

  // O servidor so devolve chave com contagem presente. Escrever so nas chaves
  // recebidas deixava o badge de um status que sumiu do resultado filtrado
  // exibindo o numero do draw anterior, entao zera os badges da tela antes.
  // `#status-rowTotal` fica de fora: quem preenche ele e o handler acima, com o
  // `recordsDisplay`.
  const badges = dtBadges(event.target).not('[id="status-rowTotal"]');
  badges.text('0');
  badges.each((_i, el) => {
    const count = json.status_counts[el.id.slice('status-'.length)];
    if (count !== undefined) {
      el.textContent = Number(count).toLocaleString('pt-BR');
    }
  });
});
